import { API, Storage } from 'aws-amplify';
import { listEvents, getEventBySlug } from '../graphql/queries';
import { createEvent as createEventMut, deleteEvent as deleteEventMut } from '../graphql/mutations';

//fetch all events
export const fetchEvents = async (prop) => {
    const apiData = await API.graphql({ query: listEvents });
    const eventsFromAPI = apiData.data.listEvents.items;

    await Promise.all(eventsFromAPI.map(async event => {
        if(!prop.loadImageFilenameOnly)
        {       //check for and grab banner image
    if (event.bannerImage) {
            const bannerImage = await Storage.get(event.bannerImage);
            event.bannerImage = bannerImage;
        }
        //check for and grab athlete image
        if (event.athleteImage) {
            const athleteImage = await Storage.get(event.athleteImage);
            event.athleteImage = athleteImage;
        }
    }
        return event;
    }))
    return apiData.data.listEvents.items;
}

//fetch filtered events 
//TODO: build search query to replace this function which filters client side (optimization gain, no functionality gain)
export const fetchFilteredEvents = async (searchTerm, sportSearchTerm, stateSearchTerm) => {
    const apiData = await API.graphql({ query: listEvents });
    const eventsFromAPI = apiData.data.listEvents.items;

    await Promise.all(eventsFromAPI.map(async event => {
        //check for and grab banner image
        if (event.bannerImage) {
            const bannerImage = await Storage.get(event.bannerImage);
            event.bannerImage = bannerImage;
        }
        //check for and grab athlete image
        if (event.athleteImage) {
            const athleteImage = await Storage.get(event.athleteImage);
            event.athleteImage = athleteImage;
        }
        return event;
    }));

    //filter events based on keywords (checks both event name & athlete name)
    var results = apiData.data.listEvents.items.filter(events => {
        if (events.name.toLowerCase().includes(searchTerm) || events.athleteName.toLowerCase().includes(searchTerm))
            return true;
        else
            return false;
    });

    //filter by sport
    if (sportSearchTerm !== "") {
        results = results.filter(events => {
            if (events.sport !== null) {
                return events.sport.toLowerCase().includes(sportSearchTerm);
            }
            return false;
        })
    }

    //filter by state
    if (stateSearchTerm !== "") {
        results = results.filter(events => {
            if (events.state !== null) {
                return events.state.toLowerCase().includes(stateSearchTerm);
            }
            return false;
        })
    }

    return results;
}

//fetch event by slug
export const fetchEventBySlug = async (slug) => {
    const apiData = await API.graphql({ query: getEventBySlug, variables: { slug: slug } });

    return apiData.data.getEventBySlug.items[0];
}

    //create new event
    export const createEvent = async (formData) => {
        if (!formData.name) return; //check for required fields

        await API.graphql({ query: createEventMut, variables: { input: formData } }); //API call - add new event

        //check for banner image & upload
        if (formData.bannerImage) {
            const bannerImage = await Storage.get(formData.bannerImage);
            formData.bannerImage = bannerImage;
        }

        //check for athlete image & upload
        if (formData.athleteImage) {
            const athleteImage = await Storage.get(formData.athleteImage);
            formData.athleteImage = athleteImage;
        }
    }

    //delete event
    export const deleteEvent = async (id) => {
        await API.graphql({ query: deleteEventMut, variables: { input: { id } } });
    }